// Cart store with persistence in localStorage
import { createStore } from 'effector';
import { Product } from '../../../types/common';
import { addToCart, removeFromCart, updateCartItemQuantity } from './events';

export interface CartItem extends Product {
    quantity: number;
}

interface CartState {
    items: CartItem[];
}

// Load initial state from localStorage if available
const stored = typeof window !== 'undefined' ? localStorage.getItem('freshgrass-cart') : null;
const initialState: CartState = stored ? JSON.parse(stored) : { items: [] };

export const $cartState = createStore<CartState>(initialState);

$cartState
    .on(addToCart, (state, product) => {
        // Find existing cart item matching both product id and selected price token
        const existingItem = state.items.find(
            (item) => item.id === product.id && item.price_token === product.price_token,
        );
        if (existingItem) {
            // Increment quantity for the same price option
            return {
                ...state,
                items: state.items.map((item) =>
                    item.id === product.id && item.price_token === product.price_token
                        ? { ...item, quantity: item.quantity + 1 }
                        : item,
                ),
            };
        }
        // Add as a new cart entry for a different price option
        return {
            ...state,
            items: [...state.items, { ...product, quantity: 1 }],
        };
    })
    .on(removeFromCart, (state, productId) => ({
        ...state,
        items: state.items.filter(item => item.id !== productId),
    }))
    .on(updateCartItemQuantity, (state, { id, quantity }) => ({
        ...state,
        items: state.items.map(item =>
            item.id === id ? { ...item, quantity: Math.max(1, quantity) } : item
        ),
    }));

// Persist state to localStorage on every change
$cartState.watch(state => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('freshgrass-cart', JSON.stringify(state));
    }
});
